import { render, staticRenderFns } from "./order-det.vue?vue&type=template&id=47e24acf&scoped=true"
import script from "./order-det.vue?vue&type=script&lang=js"
export * from "./order-det.vue?vue&type=script&lang=js"
import style0 from "./order-det.vue?vue&type=style&index=0&id=47e24acf&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e24acf",
  null
  
)

export default component.exports